import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState, TranslationLanguageData } from './types'

export const TranslationsSlice = createSlice({
  name: 'translationsSlice',
  initialState,
  reducers: {
    setTranslationsLoading(state, action: PayloadAction<boolean>) {
      state.isTranslationsLoading = action.payload
    },
    setTranslations(
      state,
      action: PayloadAction<Record<string, TranslationLanguageData>>
    ) {
      state.items = action.payload
    },
    setTranslationsLoaded(state, action: PayloadAction<boolean>) {
      state.isTranslationsLoaded = action.payload
    },
    resetTranslations() {
      return initialState
    },
  },
})

export default TranslationsSlice.reducer
